(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expand-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class ExpandAccordion extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.isMobileMode = false;
        this.isInitializing = true;
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.handlePlayClick = this.handlePlayClick.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.expand-accordion-item');
      }

      connectedCallback() {
        this.initMuteToggleHandlers();
        this.addEventListener('click', this.handlePlayClick);
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handlePlayClick);
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
        this.removeMuteToggleHandlers();
      }

      initSwiper() {
        if (this.swiperInstance) return;

        if (this.classList.contains('expand-accordion-folding-card') && this.isMobileMode) {
          return;
        }

        const galleryContainer = this.querySelector('.expand-accordion-item-container');
        if (!galleryContainer) return;

        this.swiperInstance = new Swiper(galleryContainer, {
          spaceBetween: 16,
          slidesPerView: 1.2,
          autoHeight: true,
          on: {
            slideChange: () => {
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });
            },
          },
          breakpoints: {
            220: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            500: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
          },
        });

      }

      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      handleResize() {
        const width = window.innerWidth;
        const shouldBeMobile = width < 1025;
        const modeChanged = shouldBeMobile !== this.isMobileMode;

        this.isMobileMode = shouldBeMobile;

        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            this.removeHoverListeners();
            this.clearActiveItems();
            setTimeout(() => this.initSwiper(), 50);
          } else {
            this.destroySwiper();
            this.addHoverListeners();
            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
            }
          }
        }

        this.isInitializing = false;
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      initMuteToggleHandlers() {
        const muteButtons = this.querySelectorAll('.expand-accordion-mute-toggle');
        muteButtons.forEach((button) => {
          if (button.__expandMuteClick) return;

          button.__expandMuteClick = (event) => {
            event.preventDefault();
            event.stopPropagation();

            const item = button.closest('.expand-accordion-item');
            const video = item?.querySelector('yg-video');
            if (video && typeof video.toggleMute === 'function') {
              video.toggleMute(button);
            }
          };

          button.addEventListener('click', button.__expandMuteClick);
        });
      }

      removeMuteToggleHandlers() {
        const muteButtons = this.querySelectorAll('.expand-accordion-mute-toggle');
        muteButtons.forEach((button) => {
          if (!button.__expandMuteClick) return;
          button.removeEventListener('click', button.__expandMuteClick);
          delete button.__expandMuteClick;
        });
      }

      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }

      controlVideo(item, action) {
        const videoElement = item.querySelector('yg-video');
        if (videoElement && videoElement.pauseVideo) {
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }

      handlePlayClick(event) {
        const playButton = event.target.closest('.yg-play-video');
        if (!playButton || !this.contains(playButton)) return;

        const currentItem = playButton.closest('.expand-accordion-item');
        if (!currentItem) return;

        this.items.forEach((item) => {
          if (item !== currentItem) {
            this.controlVideo(item, 'pause');
          }
        });
      }

      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;

        if (type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
          });
          target.classList.add('active');
          this.currentActiveItem = target;

          if (!this.isMobileMode && this.items.length > 3) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('expand-accordion')) {
      window.customElements.define('expand-accordion', ExpandAccordion);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 调整图片高度实现等高效果（桌面端）
  adjustImagesHeight();
  
  // 窗口大小改变时重新调整
  window.addEventListener('resize', debounce(function() {
    adjustImagesHeight();
  }, 200));
});

function adjustImagesHeight() {
  if (window.innerWidth >= 750) {
    const items = document.querySelectorAll('.image-showcase__grid--horizontal .image-showcase__item');
    // 重置所有项目的高度
    items.forEach(item => {
      item.style.height = 'auto';
    });
    
    // 检查图片是否已加载
    const checkImagesLoaded = () => {
      let allLoaded = true;
      const images = document.querySelectorAll('.image-showcase__grid--horizontal .image-showcase__image');
      
      images.forEach(img => {
        if (!img.complete) {
          allLoaded = false;
        }
      });
      
      return allLoaded;
    };
    
    // 如果所有图片都已加载，则执行调整
    if (checkImagesLoaded()) {
      setEqualHeight();
    } else {
      // 否则，等待图片加载完成
      const images = document.querySelectorAll('.image-showcase__grid--horizontal .image-showcase__image');
      let loadedCount = 0;
      const totalImages = images.length;
      
      images.forEach(img => {
        if (img.complete) {
          loadedCount++;
          if (loadedCount === totalImages) {
            setEqualHeight();
          }
        } else {
          img.addEventListener('load', () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              setEqualHeight();
            }
          });
        }
      });
    }
  }
}

function setEqualHeight() {
  const items = document.querySelectorAll('.image-showcase__grid--horizontal .image-showcase__item');
  if (items.length > 1) {
    // 找出最大高度
    let maxHeight = 0;
    items.forEach(item => {
      const height = item.offsetHeight;
      maxHeight = Math.max(maxHeight, height);
    });
    
    // 设置所有项目为相同高度
    if (maxHeight > 0) {
      items.forEach(item => {
        item.style.height = `${maxHeight}px`;
      });
    }
  }
}

// 工具函数：防抖
function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func.apply(context, args);
    }, wait);
  };
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-points-ways"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('member-points-ways')) {
    customElements.define(
      'member-points-ways',
      class extends HTMLElement {
        connectedCallback() {
          this.handleActionClick = this.handleActionClick.bind(this);
          this.addEventListener('click', this.handleActionClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleActionClick);
        }

        handleActionClick(event) {
          const target = event.target instanceof Element ? event.target : null;
          const actionButton = target?.closest('[data-member-points-smile-action]');

          if (!actionButton || !this.contains(actionButton)) return;
          if (!window.SmileUI || typeof window.SmileUI.openPanel !== 'function') return;

          window.SmileUI.openPanel({ deep_link: 'points_activity_rules' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-box-terms-bar"] && !Shopify.designMode) return;
  try {
    
  class MysteryBoxTermsBar extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector('[data-terms-open]');
      this.dialog = this.querySelector('[data-terms-dialog]');
      this.closeButton = this.querySelector('[data-terms-close]');

      if (!this.openButton || !this.dialog) return;

      this.openHandler = this.open.bind(this);
      this.closeHandler = this.close.bind(this);
      this.backdropHandler = this.handleBackdropClick.bind(this);
      this.cancelHandler = this.handleCancel.bind(this);

      this.openButton.addEventListener('click', this.openHandler);
      this.dialog.addEventListener('click', this.backdropHandler);
      this.dialog.addEventListener('cancel', this.cancelHandler);

      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.closeHandler);
      }
    }

    disconnectedCallback() {
      if (this.openButton) {
        this.openButton.removeEventListener('click', this.openHandler);
      }

      if (this.dialog) {
        this.dialog.removeEventListener('click', this.backdropHandler);
        this.dialog.removeEventListener('cancel', this.cancelHandler);
      }

      if (this.closeButton) {
        this.closeButton.removeEventListener('click', this.closeHandler);
      }
    }

    withTransition(callback) {
      if (document.startViewTransition) {
        document.startViewTransition(callback);
        return;
      }

      callback();
    }

    open() {
      if (!this.dialog || this.dialog.open) return;

      this.withTransition(() => {
        if (this.dialog.showModal) {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        requestAnimationFrame(() => {
          this.dialog.classList.add('is-open');
        });
      });
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;

      this.withTransition(() => {
        this.dialog.classList.remove('is-open');
        window.setTimeout(() => {
          if (this.dialog.open) {
            this.dialog.close();
          }
        }, 180);
      });
    }

    handleBackdropClick(event) {
      if (event.target === this.dialog) {
        this.close();
      }
    }

    handleCancel(event) {
      event.preventDefault();
      this.close();
    }
  }

  if (!customElements.get('mystery-box-terms-bar')) {
    customElements.define('mystery-box-terms-bar', MysteryBoxTermsBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purchase-hover-expand-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('.purchase-hover-expand-cards__track').forEach((track) => {
        if (track.dataset.hoverExpandReady === 'true') return;

        const cards = Array.from(track.querySelectorAll('.purchase-hover-expand-cards__card'));
        if (!cards.length) return;

        const defaultCard = cards.find((card) => card.classList.contains('is-default')) || cards[0];
        const activate = (activeCard) => {
          cards.forEach((card) => {
            card.classList.toggle('is-active', card === activeCard);
          });
        };

        track.dataset.hoverExpandReady = 'true';
        track.classList.add('is-ready');
        activate(defaultCard);

        cards.forEach((card) => {
          card.addEventListener('mouseenter', () => activate(card));
          card.addEventListener('focusin', () => activate(card));
          card.addEventListener('click', () => activate(card), { passive: true });
        });

        track.addEventListener('mouseleave', () => activate(defaultCard));
        track.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!track.contains(document.activeElement)) {
              activate(defaultCard);
            }
          }, 0);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wj-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class WJAccordion extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.isMobileMode = false;
        this.isInitializing = true; // 标记正在初始化
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.wj-accordion-item');
      }

      checkScrollClass() {
        const inner = this.querySelector('.wj-accordion-item-inner');
        if (inner) {
          let visibleCount = 0;
          this.items.forEach((item) => {
            if (item.style.display !== 'none') visibleCount++;
          });
          if (visibleCount > 3) {
            inner.classList.add('has-scroll');
          } else {
            inner.classList.remove('has-scroll');
          }
        }
      }

      connectedCallback() {
        this.checkScrollClass();
        // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);

        // 初始化过滤颜色组 0，避免出现全部项
        this.filterByColorGroup('0');

        // Listen for wj-color-switch event to filter items by color group
        document.addEventListener('wj-color-switch', (e) => {
          if (e.detail && typeof e.detail.index === 'number') {
            this.filterByColorGroup(String(e.detail.index));
          }
        });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
      }

      initSwiper() {
        if (this.swiperInstance) return;

        // 如果是 folding card 模式且在移动端，不初始化轮播
        if (this.classList.contains('wj-accordion-folding-card') && this.isMobileMode) {
          return;
        }

        const galleryContainer = this.querySelector('.wj-accordion-item-container');
        if (!galleryContainer) return;

        this.swiperInstance = new Swiper(galleryContainer, {
          spaceBetween: 16,
          slidesPerView: 1.2,
          autoHeight: true,
          on: {
            slideChange: () => {
              // 暂停所有视频
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });
              // 播放当前活动的slide的视频
              const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                this.controlVideo(activeSlide, 'play');
              }
            },
          },
          breakpoints: {
            220: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            500: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
          },
        });

        // 初始化时播放第一个活动的slide的视频
        setTimeout(() => {
          const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
          if (activeSlide) {
            this.controlVideo(activeSlide, 'play');
          }
        }, 100);
      }

      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      filterByColorGroup(colorIndex) {
        const items = this.querySelectorAll('.wj-accordion-item');
        let firstVisible = null;
        let visibleCount = 0;
        let requiresSwiperRebuild = false;

        items.forEach((item) => {
          const group = item.dataset.colorGroup || '0';
          const wasVisible = item.style.display !== 'none';
          const shouldBeVisible = (group === colorIndex);

          if (shouldBeVisible) {
            item.style.display = '';
            item.classList.add('swiper-slide');
            visibleCount++;
            if (!firstVisible) firstVisible = item;
            if (!wasVisible) requiresSwiperRebuild = true;
          } else {
            item.style.display = 'none';
            item.classList.remove('active');
            item.classList.remove('swiper-slide');
            if (wasVisible) requiresSwiperRebuild = true;
          }
        });

        // Update active flex based on visible item count
        const inner = this.querySelector('.wj-accordion-item-inner');
        if (inner) {
          inner.style.setProperty('--active-flex', visibleCount);
          if (visibleCount > 3) {
            inner.classList.add('has-scroll');
          } else {
            inner.classList.remove('has-scroll');
          }
        }

        // Set first visible item as active
        if (firstVisible) {
          firstVisible.classList.add('active');
          this.currentActiveItem = firstVisible;
        }

        // Rebuild swiper if in mobile mode
        if (this.isMobileMode && requiresSwiperRebuild && this.swiperInstance) {
          const container = this.querySelector('.wj-accordion-item-container');
          let oldMinHeight = '';
          if (container) {
            oldMinHeight = container.style.minHeight;
            // Lock height to prevent scroll anchoring jumps during rebuild
            container.style.minHeight = container.offsetHeight + 'px';
          }

          this.destroySwiper();
          this.initSwiper();

          if (container) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                container.style.minHeight = oldMinHeight;
              });
            });
          }
        }

        // Re-add hover listeners on PC
        if (!this.isMobileMode) {
          this.removeHoverListeners();
          this.addHoverListeners();
        }
      }

      handleResize() {
        const width = window.innerWidth;
        const shouldBeMobile = width < 1025;
        const modeChanged = shouldBeMobile !== this.isMobileMode;

        // 更新当前模式
        this.isMobileMode = shouldBeMobile;

        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            // 切换到移动端模式
            this.removeHoverListeners();
            this.clearActiveItems();
            // 同步初始化轮播，避免布局跳跃
            this.initSwiper();
          } else {
            // 切换到PC端模式
            this.destroySwiper();
            this.addHoverListeners();
            // 重新激活当前项目（如果有的话）
            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }
        }

        // 标记初始化完成
        this.isInitializing = false;
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }

      controlVideo(item, action) {
        const videoElement = item.querySelector('yg-video');
        if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
          // 检查是否有实际的视频内容
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'play') {
              videoElement.playVideo();
            } else if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }

      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;

        if (type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
            this.controlVideo(item, 'pause');
          });
          target.classList.add('active');
          this.controlVideo(target, 'play');
          this.currentActiveItem = target;

          if (!this.isMobileMode) {
            const inner = this.querySelector('.wj-accordion-item-inner');
            if (inner && inner.classList.contains('has-scroll')) {
              target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          }
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('wj-accordion')) {
      window.customElements.define('wj-accordion', WJAccordion);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGAccordion extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.isMobileMode = false;
        this.isInitializing = true; // 标记正在初始化
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.yg-accordion-item');
      }

      connectedCallback() {
        // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
      }

      initSwiper() {
        if (this.swiperInstance) return;

        // 如果是 folding card 模式且在移动端，不初始化轮播
        if (this.classList.contains('yg-accordion-folding-card') && this.isMobileMode) {
          return;
        }

        const galleryContainer = this.querySelector('.yg-accordion-item-container');
        if (!galleryContainer) return;

        this.swiperInstance = new Swiper(galleryContainer, {
          spaceBetween: 16,
          slidesPerView: 1.2,
          autoHeight: true,
          on: {
            slideChange: () => {
              // 暂停所有视频
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });
              // 播放当前活动的slide的视频
              const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                this.controlVideo(activeSlide, 'play');
              }
            },
          },
          breakpoints: {
            220: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            500: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 1.8,
              spaceBetween: 16,
            },
          },
        });

        // 初始化时播放第一个活动的slide的视频
        setTimeout(() => {
          const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
          if (activeSlide) {
            this.controlVideo(activeSlide, 'play');
          }
        }, 100);
      }

      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      handleResize() {
        const width = window.innerWidth;
        const shouldBeMobile = width < 1025;
        const modeChanged = shouldBeMobile !== this.isMobileMode;

        // 更新当前模式
        this.isMobileMode = shouldBeMobile;

        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            // 切换到移动端模式
            this.removeHoverListeners();
            this.clearActiveItems();
            // 延迟初始化轮播，确保DOM已准备好
            setTimeout(() => this.initSwiper(), 50);
          } else {
            // 切换到PC端模式
            this.destroySwiper();
            this.addHoverListeners();
            // 重新激活当前项目（如果有的话）
            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }
        }

        // 标记初始化完成
        this.isInitializing = false;
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }

      controlVideo(item, action) {
        const videoElement = item.querySelector('yg-video');
        if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
          // 检查是否有实际的视频内容
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'play') {
              videoElement.playVideo();
            } else if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }

      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;

        if (type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
            this.controlVideo(item, 'pause');
          });
          target.classList.add('active');
          this.controlVideo(target, 'play');
          this.currentActiveItem = target;

          if (!this.isMobileMode && this.items.length > 3) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('yg-accordion')) {
      window.customElements.define('yg-accordion', YGAccordion);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-car-hover-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('.yg-car-hover-cards__track').forEach((track) => {
        if (track.dataset.hoverExpandReady === 'true') return;

        const cards = Array.from(track.querySelectorAll('.yg-car-hover-cards__card'));
        if (!cards.length) return;

        const defaultCard = cards.find((card) => card.classList.contains('is-default')) || cards[0];
        const activate = (activeCard) => {
          cards.forEach((card) => {
            card.classList.toggle('is-active', card === activeCard);
          });
        };

        track.dataset.hoverExpandReady = 'true';
        track.classList.add('is-ready');
        activate(defaultCard);

        cards.forEach((card) => {
          card.addEventListener('mouseenter', () => activate(card));
          card.addEventListener('focusin', () => activate(card));
          card.addEventListener('click', () => activate(card), { passive: true });
        });

        track.addEventListener('mouseleave', () => activate(defaultCard));
        track.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!track.contains(document.activeElement)) {
              activate(defaultCard);
            }
          }, 0);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-member-photo-wall"] && !Shopify.designMode) return;
  try {
    
  class YGMemberPhotoWallElement extends HTMLElement {
    constructor() {
      super();
      // bound callbacks so they can be added/removed reliably
      this._intersectionCallback = this._intersectionCallback.bind(this);
      this._onResize = this._onResize.bind(this);
      this._observer = null;
    }

    connectedCallback() {
      // Initialize observer when element is attached (only active on small screens)
      this._initObserver();
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      // Cleanup when element is removed
      this._disconnectObserver();
      window.removeEventListener('resize', this._onResize);
    }

    // Create IntersectionObserver and start observing this element
    _initObserver() {
      // Only initialize on small screens
      if (window.innerWidth >= 700) {
        // ensure active class is removed when not in small-screen mode
        this._removeActive();
        return;
      }

      if (this._observer) return;
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(this._intersectionCallback, {
          root: null,
          rootMargin: '0px',
          threshold: [0, 0.75, 1]
        });
        this._observer.observe(this);
      } else {
        // Fallback: immediately mark active for small screens
        this._addActive();
      }
    }

    // Disconnect and cleanup observer
    _disconnectObserver() {
      if (!this._observer) return;
      try {
        this._observer.unobserve(this);
        this._observer.disconnect();
      } catch (err) {
        // ignore cleanup errors
      }
      this._observer = null;
    }

    // Handle window resize: enable/disable observer when crossing 700px breakpoint
    _onResize() {
      const isSmall = window.innerWidth < 700;
      const hasObserver = !!this._observer;
      if (isSmall && !hasObserver) {
        this._initObserver();
      } else if (!isSmall && hasObserver) {
        this._disconnectObserver();
        this._removeActive();
      }
    }

    // IntersectionObserver callback - separated for testability
    _intersectionCallback(entries) {
      for (const entry of entries) {
        if (entry.target !== this) continue;
        const ratio = entry.intersectionRatio || 0;
        if (entry.isIntersecting && ratio >= 0.75) {
          this._addActive();
        } else {
          this._removeActive();
        }
      }
    }

    // Add active class if not present
    _addActive() {
      if (!this.classList.contains('active')) {
        this.classList.add('active');
      }
    }

    // Remove active class if present
    _removeActive() {
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      }
    }
  }

  if (!window.customElements.get('yg-member-photo-wall')) {
    window.customElements.define('yg-member-photo-wall', YGMemberPhotoWallElement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
